var render = function render(){var _vm=this,_c=_vm._self._c;return _c('validation-observer',{attrs:{"tag":_vm.tag},scopedSlots:_vm._u([{key:"default",fn:function({valid, errors}){return [_vm._t("default",null,null,{valid, errors, labelCol: _vm.computedLabelCol, col: _vm.computedCol, hintCol: _vm.computedHintCol})]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }